import { ServerClient } from 'common/utils/http/http-clients';
import { ICitationMove, ICitationRead, IEditCitationLicensePlate, ILicensePlateDrivingPrivilegesRead } from './citation.service.types';
import { IResponseList } from 'common/models/response-list.interface';

class CitationService {
  async getCitations(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
  ): Promise<IResponseList<ICitationRead>> {
    const res = await ServerClient.get<IResponseList<ICitationRead>>('citations', {
      params: {
        filter,
        ...pageLimit,
        sort,
      },
    });
    return res?.data;
  }
  async cancel(id: number): Promise<void> {
    const res = await ServerClient.post(`citations/${id}/actions/cancel`);
    return res?.data;
  }

  async confirmPayment(id: number): Promise<void> {
    const res = await ServerClient.post(`citations/${id}/actions/paid`);
    return res?.data;
  }

  async approve(id: number): Promise<void> {
    const res = await ServerClient.post(`citations/${id}/actions/approve`);
    return res?.data;
  }

  async move(citationId: number, model: ICitationMove): Promise<ICitationRead> {
    const res = await ServerClient.post(`citations/${citationId}/move`, model);
    return res?.data;
  }

  async editLicensePlate(citationId: number, model: IEditCitationLicensePlate): Promise<ICitationRead> {
    const res = await ServerClient.put(`citations/${citationId}/license-plate`, model);
    return res?.data;
  }

  async isLicensePlateDrivingPrivilegesRevoked(licensePlate: string): Promise<ILicensePlateDrivingPrivilegesRead> {
    const res = await ServerClient.get(`citations/license-plates/${licensePlate}/driving-privileges-revoked`);
    return res?.data;
  }
}

export const citationService = new CitationService();
export default citationService;
